import React from "react";

export function Field({
  label,
  required = false,
  help,
  error,
  children,
  htmlFor,
  style,
}) {
  const message = error || help;
  return (
    <label
      htmlFor={htmlFor}
      style={{
        display: "flex",
        flexDirection: "column",
        gap: 6,
        ...(style || {}),
      }}
    >
      {label && (
        <span
          style={{
            fontSize: 12,
            fontWeight: 500,
            color: "var(--kr-fg-strong)",
          }}
        >
          {label}
          {required && (
            <span style={{ color: "var(--kr-danger-500)", marginLeft: 2 }}>*</span>
          )}
        </span>
      )}
      {children}
      {message && (
        <span
          style={{
            fontSize: 11,
            color: error ? "var(--kr-danger-700)" : "var(--kr-fg-muted)",
          }}
        >
          {message}
        </span>
      )}
    </label>
  );
}

export default Field;
